import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"

import Breadcrumb from "./breadcrumb"

const InfoLayoutRebrand = ({ children, title }) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <div className="contained-wide widescreen:px-60 px-16">
      <Breadcrumb title={title} />
    </div>
    {children}
  </>
)

InfoLayoutRebrand.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
}

export default InfoLayoutRebrand
